import React from 'react'
import { useNavigate } from 'react-router-dom'
import { AppTooltip } from './AppTooltip'

/**
 * DateModifiedIcon
 * Renders a subtle, clean indicator icon next to dates that have been modified.
 * Clicking navigates directly to the Audit Logs screen with the record pre-expanded.
 *
 * @param {boolean} hasDateChanges - Whether the entity has recorded date changes
 * @param {string} module - 'PROJECT' | 'TASK' | 'JOB' | 'TIMESHEET'
 * @param {number|string} entityId - The ID of the entity
 * @param {string} className - Optional container styling classes
 */
export default function DateModifiedIcon({
  hasDateChanges = false,
  module = '',
  entityId = '',
  className = '',
}) {
  const navigate = useNavigate()

  if (!hasDateChanges || !entityId) {
    return null
  }

  const handleClick = (e) => {
    e.stopPropagation()
    const targetModule = String(module || '').toUpperCase()
    const targetUrl = `/audit-logs?module=${encodeURIComponent(targetModule)}&entityId=${encodeURIComponent(entityId)}&autoExpand=true`
    navigate(targetUrl)
  }

  return (
    <AppTooltip content="Date modified. Click to view change history in Audit Logs." side="top">
      <button
        type="button"
        onClick={handleClick}
        className={`inline-flex items-center justify-center h-4 w-4 rounded-full text-amber-600 hover:text-amber-700 hover:bg-amber-100/70 transition-all cursor-pointer focus:outline-none focus:ring-1 focus:ring-amber-500/50 ${className}`}
        aria-label="View date change audit history"
      >
        <span className="material-symbols-outlined text-[14px] leading-none select-none">history</span>
      </button>
    </AppTooltip>
  )
}
